import { useState } from 'react';

interface InventoryData {
  id: string;
  area: string;
  cargoType: string;
  volume: number;
  weight: number;
  scanTime: string;
  status: string;
}

export default function ProductionInventory() {
  const [inventoryData] = useState<InventoryData[]>([
    { id: 'A01', area: '1号堆场', cargoType: '煤炭', volume: 12580, weight: 15800, scanTime: '2025-01-15 09:30', status: '正常' },
    { id: 'A02', area: '2号堆场', cargoType: '铁矿石', volume: 8960, weight: 22400, scanTime: '2025-01-15 10:15', status: '正常' },
    { id: 'B01', area: '3号堆场', cargoType: '散粮', volume: 6720, weight: 5040, scanTime: '2025-01-15 11:00', status: '苫盖异常' },
    { id: 'B02', area: '4号堆场', cargoType: '煤炭', volume: 15200, weight: 19000, scanTime: '2025-01-15 08:45', status: '正常' },
    { id: 'C01', area: '5号堆场', cargoType: '矿石', volume: 10400, weight: 26000, scanTime: '2025-01-15 09:00', status: '非计划动货' },
    { id: 'C02', area: '6号堆场', cargoType: '散粮', volume: 7800, weight: 5850, scanTime: '2025-01-15 10:30', status: '正常' },
  ]);

  const totalVolume = inventoryData.reduce((sum, item) => sum + item.volume, 0);
  const totalWeight = inventoryData.reduce((sum, item) => sum + item.weight, 0);
  const abnormalCount = inventoryData.filter(item => item.status !== '正常').length;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-white">智能盘垛与库存管理</h2>
        <button className="px-4 py-2 bg-teal-500 text-white text-sm rounded-lg hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer">
          <i className="ri-refresh-line mr-2"></i>刷新数据
        </button>
      </div>

      <div className="grid grid-cols-4 gap-4">
        <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-slate-400 text-sm">总体积</span>
            <i className="ri-stack-line text-teal-400 text-xl"></i>
          </div>
          <div className="text-2xl font-bold text-white">{totalVolume.toLocaleString()}</div>
          <div className="text-xs text-slate-500 mt-1">立方米</div>
        </div>

        <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-slate-400 text-sm">总重量</span>
            <i className="ri-scales-3-line text-teal-400 text-xl"></i>
          </div>
          <div className="text-2xl font-bold text-white">{totalWeight.toLocaleString()}</div>
          <div className="text-xs text-slate-500 mt-1">吨</div>
        </div>

        <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-slate-400 text-sm">堆场数量</span>
            <i className="ri-building-2-line text-teal-400 text-xl"></i>
          </div>
          <div className="text-2xl font-bold text-white">{inventoryData.length}</div>
          <div className="text-xs text-slate-500 mt-1">个</div>
        </div>

        <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-slate-400 text-sm">异常堆场</span>
            <i className="ri-alert-line text-orange-400 text-xl"></i>
          </div>
          <div className="text-2xl font-bold text-orange-400">{abnormalCount}</div>
          <div className="text-xs text-slate-500 mt-1">个</div>
        </div>
      </div>

      <div className="bg-slate-800/50 border border-slate-700 rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-slate-900/50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">堆场编号</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">区域</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">货物类型</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">体积(m³)</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">重量(吨)</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">扫描时间</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">状态</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">操作</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-700">
              {inventoryData.map((item) => (
                <tr key={item.id} className="hover:bg-slate-700/30 transition-colors">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-white">{item.id}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-300">{item.area}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-300">{item.cargoType}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-300">{item.volume.toLocaleString()}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-300">{item.weight.toLocaleString()}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-300">{item.scanTime}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    <span className={`px-2 py-1 rounded-full text-xs ${
                      item.status === '正常' ? 'bg-teal-500/20 text-teal-400' : 'bg-orange-500/20 text-orange-400'
                    }`}>
                      {item.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    <button className="text-teal-400 hover:text-teal-300 mr-3 cursor-pointer">
                      <i className="ri-eye-line"></i>
                    </button>
                    <button className="text-slate-400 hover:text-slate-300 cursor-pointer">
                      <i className="ri-download-line"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
